import { render, staticRenderFns } from "./InternationalCard.vue?vue&type=template&id=05f40280&scoped=true&"
import script from "./InternationalCard.vue?vue&type=script&lang=js&"
export * from "./InternationalCard.vue?vue&type=script&lang=js&"
import style0 from "./InternationalCard.vue?vue&type=style&index=0&id=05f40280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f40280",
  null
  
)

export default component.exports